import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

const Modal = ({ closeModalHandler, children, className, closeBtn }) => {

  useEffect(function () {
    document.body.classList.add('no-scroll')
    return function () {
      document.body.classList.remove('no-scroll')
    }
  })

  return (
    <div className={`popup ${className}`}>
      <div className="popup__content">
        {closeBtn ? (
          <button type="button" className="popup__close" onClick={closeModalHandler}>
            <span>Close</span>
          </button>
        ) : null}
        {children}
      </div>
      <div className="popup__background-layer" />
    </div>
  );
};

export default Modal;

Modal.propTypes = {
  className: PropTypes.string,
  closeModalHandler: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  closeBtn: PropTypes.bool.isRequired,
};
Modal.defaultProps = {
  className: '',
};
